import posthog from 'posthog-js'

let initialized = false

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key || initialized) return
  posthog.init(key, {
    api_host: 'https://app.posthog.com',
    capture_pageview: false,
    autocapture: false,
  })
  initialized = true
}

export function track(event: string, props?: Record<string, unknown>) {
  if (!initialized) return
  posthog.capture(event, props)
}

export function identify(userId: string | number, traits?: Record<string, unknown>) {
  if (!initialized) return
  posthog.identify(String(userId), traits)
}

export function reset() {
  if (!initialized) return
  posthog.reset()
}
